<template>
  <v-container>
     <v-card-title>
          <i class="material-icons">record_voice_over</i>
          <span > &nbsp;&nbsp; {{ TextShow(totalItems)}}</span>
            <v-spacer class="hidden-xs-only"></v-spacer><v-spacer class="hidden-xs-only"></v-spacer>
          </v-card-title>

    <v-layout row wrap>
      <v-flex xs12>
        <v-card v-show="totalItems!==0">
          <v-card-text class="hidden-sm-and-up mb-0 pb-0">
            <h3>{{label}}</h3>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-list v-bind:items="items" :loading="loading">
      <template v-for="item in items">
        <v-card v-bind:key="item.title">
          <v-divider></v-divider>
          <v-list-item v-bind:key="item.title">
            <v-list-item-avatar>
              <img :src="apiPath+'content/emp_img.asp?w=450&img='+item.AssignFrom+'.jpg'" />
            </v-list-item-avatar>
            <v-list-item-content >
              <span>to - {{ item.AssignTo | empName(allPerson)}}<br></span>
              <span v-show="item.AssignCC">cc - {{(item.AssignCC) | empName(allPerson)}}</span>
              <div v-if = "adddDays(item.insertDate,30)" >
                 <span class="grey--text text--lighten-1 caption"> {{item.insertDate | datedif}} {{item.insertDate |date}} , {{(item.modifyCode)}}</span>
              </div>
              <div v-else>
                  <span class="grey--text text--lighten-1 caption"> {{item.insertDate | date}} , {{item.modifyCode}}</span>
              </div>
            </v-list-item-content>


            <v-list-item-action v-if="hasFiles(item.List) > [0] && false">
              <a>
                <v-icon @click="getFilesDetail(item.List)" v-bind:color="item.active ? 'teal' : 'grey'">attach_file</v-icon>
              </a>
            </v-list-item-action>
            <v-list-item-action v-if="item.hasFile === 'Y'">
              <a>
                <v-icon @click="getFilesDetailV2(item.List)" v-bind:color="item.active ? 'teal' : 'grey'">attach_file</v-icon>
              </a>
            </v-list-item-action>
            <!-- <div v-if="$store.state.users.Permission[0].PermissionD !== undefined && $store.state.users.Permission[0].PermissionD >= 2"> -->
            <div v-if= "$store.state.users.main.Department === 'Information Technology Division' || $store.state.users.main.empCode === '0123'|| $store.state.users.main.empCode === '0223'">
            <v-btn fab dark small color="red" @click="ConfirmDelete(item)" ><v-icon>delete</v-icon></v-btn>
            </div>
          </v-list-item>
          <div v-if= "item.modifyCode === $store.state.users.main.empCode || $store.state.users.main.Department === 'Information Technology Division'">
            <v-card-text @click.stop="setCurrentBookDT(item)">
              <div>
                <pre>{{CutStr1(item.Memo)}}<span v-show="!item.longMemo && CutStr2(item.Memo).length > 0" @click="CutStrToggle(item)"><a>...อ่านต่อ</a></span><span v-show="item.longMemo">{{CutStr2(item.Memo)}}</span></pre>
              </div>
            </v-card-text>
          </div>
          <div v-else>
            <v-card-text>
              <div>
                {{CutStr1(item.Memo)}}
                <span v-show="!item.longMemo && CutStr2(item.Memo).length > 0" @click="CutStrToggle(item)">
                  <a>...อ่านต่อ</a>
                </span>
                <span v-show="item.longMemo">{{CutStr2(item.Memo)}}</span>
              </div>
            </v-card-text>
          </div>
        </v-card>
      </template>

    </v-list>
    <v-dialog v-model="dialog2" max-width="500px">
      <v-card>
        <v-toolbar color="cyan" dark>
          <v-toolbar-title>มอบหมายงาน / การดำเนินงาน </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon  @click.stop="setUpload()">
            <v-icon >attach_file</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <person-input label="เพื่อดำเนินการ (เพื่อดำเนินการ สถานะงานจะถูกตั้งเป็น 'ระหว่างดำเนินการ' )" v-model="bookdt.AssignTo"></person-input>
          <person-input label="เพื่อทราบ (เพื่อทราบ สถานะงานจะคงเดิมไม่เปลี่ยนแปลง)" v-model="bookdt.AssignCC"></person-input>
          <!-- <v-text-field label="Memo" placeholder="Memo" v-model="bookdt.Memo" ref="Memo"></v-text-field> -->
          <v-textarea label="Memo" placeholder="Memo" v-model="bookdt.Memo" ref="Memo"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="loading" color="primary" text @click.stop="subDT()">save</v-btn>
          <v-btn color="primary" text @click.stop="dialog2=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog3" max-width="500px">
      <v-card>
        <v-toolbar color="cyan" dark>
          <v-toolbar-title>(3)</v-toolbar-title>
        </v-toolbar>
        <dropzone-v2
          dzName="bookin_Att_DTlist3"
          ref="dzv2_DTlist3"
          :appName="'bookin'"
          :code="''+BookID"
          :list="''+fileList"
          :maxSize="20"
          :nameCode="'*'"
          :canDelete="true"
          :canUpload="true"
          @uploadSuccess="uploadOK"
        ></dropzone-v2>
        <dropzone-comp v-if="false" class="pb-1" ref="bookDTdz" :book="$route.params.id" :list="bookdt.List" dzName="DT"></dropzone-comp>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.stop="dialog3=false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog4" max-width="500px">
      <v-flex>
        <v-card>
          <v-card-title>
            <h5>ไฟล์แนบ</h5>
          </v-card-title>
          <v-card-text>
            <dropzone-v2
              dzName="bookin_Att_DTlist4"
              ref="dzv2_DTlist4"
              :appName="'bookin'"
              :code="''+BookID"
              :list="''+fileList"
              :maxSize="20"
              :nameCode="'*'"
              :canDelete="false"
              :canUpload="false"
            ></dropzone-v2>
            <div v-show="false" v-for="item in fileDetail" :key="'fileDetail'+item.DateCreated">
              <a :href="serverName+item.Link" target="_blank">
                <v-icon left>note</v-icon>
                {{item.Name}}
              </a>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click.stop="dialog4=false;fileList=0">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-dialog>
  </v-container>
</template>
<script>
import bookServ from '@/store/api/services/bookService'
export default {
  data() {
    return {
      rootPath: process.env.VUE_APP_ROOT_PATH,
      serverName: process.env.VUE_APP_SERVER_NAME,
      apiPath: process.env.VUE_APP_API_PATH,
      search: '',
      error: null,
      totalItems: 0,
      items: [],
      fileDetail: [],
      fileDetailV2: [],
      bookdt: { ID: 0, Memo: '', List: 0 },
      loading: true,
      pagination: { sortBy: 'insertDate desc', page: 1, rowsPerPage: 0 },
      dialog2: false,
      dialog3: false,
      dialog4: false,
      fileList: 0,
      headers: [
        // { text: 'ID', value: 'ID', align: 'left' },
        { text: 'ลำดับ', value: 'List', align: 'center' },
        { text: 'จาก', value: 'AssignFrom', align: 'center' },
        { text: 'ถึง', value: 'AssignTo', align: 'center' },
        { text: 'Memo', value: 'Memo', align: 'center' },
        { text: 'สถานะ', value: 'status', align: 'center' },
        { text: 'ไฟล์แนบ', value: 'hasFile', align: 'center' },
        { text: 'วันที่แจ้ง', value: 'insertDate', align: 'center' }
      ]
    }
  },
  watch: {
    search: {
      handler() {
        // console.log('watch search', this.search)
      }
    },
    items: {
      handler(val) {
        console.log('val', val)
      },
      deep: true
    }
  },
  mounted() {
    this.DT_list()
  },
  props: {
    BookID: {
      type: String,
      default: '0'
    },
    label: {
      type: String,
      default: ''
    }
  },
  computed: {
    allPerson: function () {
      if (localStorage.getItem('EmpAll') !== '') {
        return JSON.parse(localStorage.getItem('EmpAll'))
      }
      localStorage.setItem('EmpAll', JSON.stringify(this.$store.state.users.empAll))
      return this.$store.state.users.empAll
    },
    allDep: function () {
      return this.$store.state.users.dep
    }
  },
  methods: {
    adddDays(d,days)
    {
      // d = '2020-11-02T16:54:36700:00'
      var txtDate = d.substring(0,19) //'2020-11-02T16:54:36'
      
      txtDate = txtDate.replace('T', ' ') //'2020-11-02 16:54:36'
      txtDate = txtDate + ' +0700' //'2020-11-02 16:54:36 +0700'
      var tempD = new Date(txtDate)
      var dat = new Date(tempD.setDate(tempD.getDate() + parseInt(days)))
      var cdate = new Date()
      return dat < cdate
    },
    async getFilesDetail(argList) {
      this.dialog4 = true
      try {
        const response = await bookServ.getFile({
          ID: this.BookID,
          List: argList
        })
        this.fileDetail = response.data.data
        return response.data.data
      } catch (e) {
        return {}
      }
    },
    async getFilesDetailV2(argList) {
      this.fileList = argList
      this.dialog4 = true
      
      // this.$refs.dzv2_DTlist4.getFiles()
      try {
        const response = await bookServ.getFileV2({
          appName: 'bookin',
          ID: this.BookID,
          List: argList
        })
        this.fileDetailV2 = response.data.data
        // alert('pom')
        console.log(this.$refs.dzv2_DTlist4.getFiles())
        return response.data.data
      } catch (e) {
        return {}
      }
    },
    filteredName: function(Type) {
      if (this.bookdt.AssignTo !== undefined) {
        return this.bookdt.AssignTo.filter(f => {
          if (f.Type === Type) return f
        })
      } else {
        return []
      }
    },
    CutStrToggle: function(item) {
      item.longMemo = !item.longMemo
    },
    TextShow: function(item) {
      if (item !== undefined) {
        var tempShow = ''
        if (item > 0) {
          tempShow = 'งานที่มอบหมาย ' + item + ' รายการ'
          return tempShow
        } else {
          tempShow = 'ไม่มีรายการที่มอบหมาย'
          return tempShow
        }
      }
    },
    CutStr1: function(item) {
      if (item !== undefined && item !== null) {
        var tempT = ''
        if (item.length > 90) {
          tempT = item.substr(0, 90)
          return tempT
        } else {
          return item
        }
      }
      return item
    },
    CutStr2: function(item) {
      if (item !== undefined && item !== null) {
        var tempT = ''
        if (item.length > 90) {
          tempT = item.substr(90, item.length)
          return tempT
        } else {
          return ''
        }
      }
      return ''
    },
    Namesplit: function(empCodes) {
      if (empCodes !== undefined && empCodes !== null) {
        var arr = empCodes.split(',')
        var Nname = ''
        var temp = []
        for (var i = 0; i < arr.length; i++) {
          temp = this.personsName(arr[i])
          if (temp.length > 0) {
            temp = temp[0].EmpName.split(' ')
            Nname += temp[0] + ','
          }
        }
      }
      return Nname
    },
    ConfirmDelete(item) {
      // alert(this.$store.state.users.Permission[0].PermissionD)
      var x = confirm('คุณแน่ใจว่าต้องการลบรายการนี้?')
      if (x === true) {
        this.DTDelete(item)
      } else {
        return false
      }
    },
    DTDelete (item) {
      this.loading = true
      // console.log('dtdelete', item)
      bookServ.bookDTDelete(item)
      .then((response) => {
        // console.log(response.data.data)
        if (response.data.error === '') {
          // ลบค่าใน array
          this.items = this.items.filter(function(el) {
            return el.ID !== item.ID || el.List !== item.List
          })
        } else {
          alert('!!เกิดข้อผิดพลาด')
        }
        this.loading = false
      })
    },
    personsName: function(EmpCode) {
      if (this.$store.state.users.persons !== undefined) {
        return this.$store.state.users.persons.filter(f => {
          if (f.EmpCode === EmpCode) return f.EmpCode === EmpCode
        })
      } else {
        return ''
      }
    },
    hasFiles: function(Name) {
      if (this.$store.state.users.getfile !== undefined) {
        Name = Name.toString()
        return this.$store.state.users.getfile.filter(f => {
          if (f.Name === Name) return f.Size > 0
        })[0]
      } else {
        return []
      }
    },
    setCurrentBookDT(item) {
      // console.log('bookdt before', this.bookdt)
      this.bookdt = item
      this.fileList = item.List
      this.bookdt.modifyCode = this.$store.state.users.main.empCode
      // console.log('bookdt after', this.bookdt)
      this.dialog2 = true
    },
    setUpload() {
      // this.$refs.bookDTdz.list = this.bookdt.List
      // this.fileList = this.bookdt.List
      this.dialog3 = true
    },
    change: function() {
      this.$router.push('/bookAdd')
    },
    showID(item) {
      console.log(item)
    },
    subDT() {
      this.dialog2 = false
      bookServ.DT_update(this.bookdt)
      .then(response => {
        if (response.data.error === '') {
          alert('เพิ่ม มอบหมายงาน / การดำเนินงาน เรียบร้อย')
          this.getBookItem()
        } else {
          alert('!!เกิดข้อผิดพลาด')
        }
        this.loading = false
      })
    },
    getBookItem () {
        // console.log('created', this.$route.params.id)
      bookServ.bookByID(this.$route.params)
      .then((response) => {
        this.books = response.data.data[0]
        this.bookID = this.books.ID
        if (this.books) {
          bookServ.getFile(this.books)
          .then((response) => {
            // console.log('file', response.data)
            this.$store.commit('setgetFile', response.data.data)
          })
        }
      })
      .catch((error) => {
        console.error(error)
      })
    },
    subDT2() {
      this.dialog2 = false
      bookServ.DT_insert(this.bookdt).then(response => {
        if (response.data.error === '') {
          alert('save')
        } else {
          alert('!!เกิดข้อผิดพลาด')
        }
        this.loading = false
      })
    },
    showBook(item) {
      this.$router.push('bookViewEdit/' + item)
    },
    uploadOK (file) {
      if (this.$refs.dzv2_DTlist3.hasFiles()) {
        this.bookdt.hasFile = 'Y'
      } else {
        this.bookdt.hasFile = '-'
      }
      bookServ.DT_update(this.bookdt)
      .then(response => {
        if (response.data.error === '') {
          this.getBookItem()
        } else {
          alert('!!เกิดข้อผิดพลาด ในการปรับปรุงสถานะว่ามีไฟล์แนบ')
        }
        this.loading = false
      })
      console.log('test', file)
    },
    async DT_list() {
      // console.log('call DT_list')
      this.loading = true
      try {
        const response = await bookServ.DT_list({
          pageNo: this.pagination.page,
          rowsPerPage: this.pagination.rowsPerPage,
          sortBy: this.pagination.sortBy,
          descending: this.pagination.descending,
          search: this.search,
          ID: this.BookID
        })
        this.loading = false
        this.items = response.data.data
        this.totalItems = response.data.totalRecords
        this.$store.commit('setLoadedbookDts', this.items)
        // this.$store.state.isAuthen = true
        return response.data
      } catch (e) {
        // console.log(e.response)
        bookServ.errorHandel(e.response)
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
code {
  background: #9e9e9e;
  color: #bd4147;
  display: inline-block;
  background-color: #f5f5f5;
  border-radius: 3px;
  white-space: pre-wrap;
  font-size: 85%;
  font-weight: 100 !important;
  font-weight: 900 !important;
}
</style>
